<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      @reset-query="$emit('reset-select')"
      :summaryMethod="summaryFunc"
      :show-summary="summaryShow"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据日期">
          <range-picker
            :date="[params.StartTime, params.EndTime]"
            @change="x=>{params.StartTime=x.Start;params.EndTime=x.End;}"
            style="min-width:200px"
          />
        </el-form-item>
        <el-form-item label="仓库名称">
          <el-select
            size="mini"
            v-model="params.WarehouseId"
            placeholder="请选择"
            clearable
          >
          <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="单据类型">
          <el-select size="mini" v-model="params.billName" placeholder="请选择" @change="changeName" clearable >
            <el-option v-for="(item,index) in billList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table" >
        <el-table-column prop="DocDate" label="单据日期" align="center">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="DocNo" label="单据编号" align="center" />
        <el-table-column prop="BillName" label="单据类型" align="center" />
        <el-table-column prop="WarehouseName" label="仓库名称" align="center" />
        <el-table-column prop="GoodsName" label="商品名称" align="center" />
        <el-table-column prop="Model" label="规格型号" align="center" />
        <el-table-column prop="UnitName" label="计量单位" align="center" />
        <el-table-column label="本期入库" align="center">
          <el-table-column prop="InQuantity" label="主数量" align="center" />
          <el-table-column prop="InPrice" label="单价" align="center" />
          <el-table-column prop="InAmount" label="金额" align="center" />
        </el-table-column>
        <el-table-column label="本期出库" align="center">
          <el-table-column prop="OutQuantity" label="主数量" align="center" />
          <el-table-column prop="OutPrice" label="单价" align="center" />
          <el-table-column prop="OutAmount" label="金额" align="center" />
        </el-table-column>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return {
      api: require("@/api/stock/stBook").default,
      wareApi: require("@/api/ba/warehouse").default,
      showType: 0,
      showList: 0,
      wareList: [],
      showSum: true,
      params: {
        StartTime: this.formatDate(firstDayOfMonth),
        EndTime: this.formatDate(lastDayOfMonth),
        ExistStatus: "",
        WarehouseId: null,
        GoodsName: "",
        billName: ""
      },
      billList: ["进货单","进货退货单","销货单","销货退货单","其他入库单","其他退库单","其他出库单"," 其他出库退库单","调拨单","产成品入库单",
                "产成品退库单","材料出库单","材料退库单"],
      summaryShow: false,
      total: null
    };
  },
  mounted() {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    this.params.StartTime = this.formatDate(firstDayOfMonth);
    this.params.EndTime = this.formatDate(lastDayOfMonth);

    this.wareApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.wareList = res.Data
      sessionStorage.setItem("ware",JSON.stringify(res.Data))
    })
  },
  methods: {
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      console.log('year',year,month,day)
      return `${year}-${month}-${day}`;
    },
    changeName(e) {
      this.$refs.list.query()
    },
    resetList(e) {
      this.showList = null
      setTimeout(() => {
        this.showList = e
      }, 20);
    },
    getDataFunc(params) {
      console.log("getDataFunc", params);
      console.log("getDataFunc", params.StartTime.toString(), params.EndTime.toString());
      return new Promise((resolve, reject) => {
        this.api.getTurnoverStat(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.getTurnoverStatTotal(params).then(res => {
              console.log("total", res)
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["InQuantity", "InAmount",'OutQuantity','OutAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            if (field === 'InQuantity' || field === 'OutQuantity') {
              sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4 })
            } else {
              sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.getTurnoverStatExport(this.params).then(() => {
        loading.close();
      });
    },
  },
};
</script>